import React, { PropTypes } from 'react';
import { Divider, Checkbox } from 'material-ui';
import AttachmentActionWidgets from './attachmentActionWidgets';
import {
  bulkDownloadS3File,
  downloadFromUrl as downloadFromUrlAction,
} from '../../../stores/actions';
import { connect } from 'react-redux';
import R from 'ramda';
import A from 'aphrodite';
const isNilOrEmpty = R.either(R.isNil, R.isEmpty);
const propTypes = {
  uploads: PropTypes.array,
  addToContractFn: PropTypes.func,
  downloadFromUrl: PropTypes.func,
  isInMessaging: PropTypes.bool,
  filesInContract: PropTypes.array,
  allowFilesToBeAddedToContract: PropTypes.bool,
  contractIdOfThread: PropTypes.string,
};

class Attachments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: {},
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }
  render() {
    const { uploads, downloadFromUrl, addToContractFn, filesInContract, allowFilesToBeAddedToContract, contractIdOfThread } = this.props;
    if (!uploads || !uploads.length) return null;
    const styleSheets = A.StyleSheet.create({
      container: { display: R.isEmpty(uploads) ? 'none' : 'block', border: '2px solid #e0e0e0', margin: '16px', with: '95%' },
      header: { textAlign: 'center', fontSize: '16px', lineHeight: '52px', height: '52px' },
      subHeader: { display: uploads.length > 1 ? 'flex' : 'none', alignItems: 'center', justifyContent: 'space-between', height: '52px', borderTop: '1px solid #e0e0e0', padding: '0 8px 0 4px' },
      filenameStyle: { overflowWrap: 'break-word', wordWrap: 'break-word', wordBreak: 'break-all', hyphens: 'auto' },
    });
    return (
      <div className={A.css(styleSheets.container)}>
        <div className={A.css(styleSheets.header)}>Message Attachments</div>
        <div className={A.css(styleSheets.subHeader)} >
          <Checkbox
            style={{ width: '175px' }}
            label="SELECT ALL"
            checked={R.keys(this.state.selected).length === uploads.length}
            onCheck={(_, checked) => {
              this.setState({ selected: checked ? uploads.reduce((result, file) => R.assoc(file._id || file.url || file.path, file, result), {}) : {} });
            }}
          />
          <AttachmentActionWidgets
            allowFilesToBeAddedToContract={allowFilesToBeAddedToContract}
            hide={isNilOrEmpty(this.state.selected)}
            downloadFn={() => bulkDownloadS3File(R.values(this.state.selected), 'Attachments')}
            addToContractFn={() => addToContractFn(R.values(this.state.selected))}
          />
        </div>
        {
          uploads.filter(x => x).map((file, i) => {
            return (
              <div key={i} style={{ color: 'rgba(0, 0, 0, 0.84)' }}>
                <Divider/>
                <div className="flex-center" style={{ lineHeight: '32px' }}>
                  <Checkbox
                    checked={Boolean(this.state.selected[file._id || file.url || file.path])}
                    disabled={uploads.length < 2}
                    style={{ width: '24px', marginLeft: '4px' }}
                    onCheck={(_, checked) => this.setState({ selected: checked ? R.assoc(file._id || file.url || file.path, file, this.state.selected) : R.omit([file._id], this.state.selected) })}
                  />
                  <div className="flex-tc-sb" style={{ width: '93%', padding: '0 8px', lineHeight: '20px' }}>
                  <span className={A.css(styleSheets.filenameStyle)}>{file.name}</span>
                    <AttachmentActionWidgets
                      allowFilesToBeAddedToContract={allowFilesToBeAddedToContract}
                      addedToContractId={R.call(R.compose(
                        R.replace('contract:', ''),
                        R.pathOr('', ['logs', 0, 'foreignIds', 0])
                      ), file)}
                      downloadFn={() => downloadFromUrl(file)}
                      addToContractFn={() => addToContractFn([file])}
                      inContractThread={Boolean(filesInContract && filesInContract.length)}
                      addedToCurrentContract={(file.logs || []).some(obj => obj.foreignIds.indexOf(`contract:${contractIdOfThread}`) > -1)}
                    />
                  </div>
                </div>
                {
                  /*
                   <div style={{ position: 'relative', bottom: '8px', padding: '0 8px 0 8px' }}>
                   <FlatButton
                   onTouchTap={() => this.setState({ [file._id]: !(this.state[file._id]) })}
                   style={{ display: file.logs && file.logs.length ? 'inline-block' : 'none', border: '1px solid #49708A', height: '24px', lineHeight: '24px', width: '88px' }}
                   label={this.state[file._id] ? 'Hide Logs' : 'Show Logs'}
                   labelStyle={{ textTransform: 'none', color: '#49708A', padding: '0', verticalAlign: '', top: '-1px' }}
                   />
                   <Logs logs={file.logs} style={{ marginTop: '8px', display: this.state[file._id] ? 'block' : 'none', width: '100%' }} />
                   </div>
                   */
                }
              </div>
            );
          })
        }
      </div>
    );
  }
}

const mapStateToProps = ({}) => ({

});

const mapDispatchToProps = dispatch => ({
  downloadFromUrl: (...args) => dispatch(downloadFromUrlAction(...args)),
});
Attachments.propTypes = propTypes;
Attachments.contextTypes = {
  router: PropTypes.object.isRequired,
};
export default connect(mapStateToProps, mapDispatchToProps)(Attachments);



// WEBPACK FOOTER //
// ./src/app/components/messaging/singleConv/regularAttachments.jsx